import React, { useMemo } from 'react';
import { isCitiesAndKnightsContext } from '@colonist/i18n';
import { useUIGameEndContext } from '../../../../../contexts/UIGameEndContext.tsx';
import { useUIGameTranslationContext } from '../../../../../contexts/UIGameTranslationContext.tsx';
import { StatsTable } from '../../StatsTable/index.ts';
import { RESOURCE_ACTIVITY_IMAGE_PATH, RESOURCE_ACTIVITY_IMAGE_PATH_CK, RESOURCE_ACTIVITY_TRANSLATION } from '../../../constants.ts';
export const ResourceStats = ()=>{
    const { gameEndData, playersByRank } = useUIGameEndContext();
    const { translationKeyContext } = useUIGameTranslationContext();
    const players = useMemo(()=>playersByRank.flatMap((player)=>player.color), [
        playersByRank
    ]);
    const headers = useMemo(()=>{
        const resourceImagePath = isCitiesAndKnightsContext(translationKeyContext) ? RESOURCE_ACTIVITY_IMAGE_PATH_CK : RESOURCE_ACTIVITY_IMAGE_PATH;
        return Object.keys(resourceImagePath).map((key)=>({
                imagePath: resourceImagePath[key],
                tooltip: RESOURCE_ACTIVITY_TRANSLATION[key].title
            }));
    }, [
        translationKeyContext
    ]);
    const rows = useMemo(()=>players.map((player)=>{
            const row = [];
            const data = gameEndData.endGameState.resourceStats[player];
            if (data === undefined) return [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            row.push(data.totalResourceIncome);
            row.push(data.totalResourceLoss);
            row.push(data.totalResourceScore);
            row.push(data.rollingIncome);
            row.push(data.robbingIncome);
            row.push(data.devCardIncome);
            row.push(data.tradeIncome);
            row.push(data.rollingLoss);
            row.push(data.robbingLoss);
            row.push(data.devCardLoss);
            row.push(data.tradeLoss);
            row.push(data.goldIncome);
            return row;
        }), [
        players
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StatsTable, {
        headers: headers,
        rows: rows
    }));
};
